import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatusSeenV4 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 9,
	viewBox: "0 0 14 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0.649902 4.5L3.3999 7.5L9.3999 1.5",
		stroke: "#9565FD",
		strokeWidth: 1.3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.34985 7.5L13.3499 1.5",
		stroke: "#9565FD",
		strokeWidth: 1.3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgStatusSeenV4;
